import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import bgImage from '../static/images/backgrounds/loader.png'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { colors } from '../styles/vars'
import SvgCircle from '../components/SvgCircle';

const infiniteMotion = keyframes`
0%{
    background-position:0;
}
100%{
    background-position:2000px;
}
`
const GeneralWrapper = styled.div`
direction:rtl;
height:calc(100vh - 41px);
background-color:${colors.black};
background-image:url(${bgImage});
background-size:cover;
animation:${infiniteMotion} 20s linear infinite;
`
const Container = styled.div`
height:100%;
display:flex;
align-items:center;
justify-content:center;
`
const LoaderContainer = styled.div`
display:inline-block;
position:relative;
`
const InnerCircle = styled.div`
width:80%;
height:80%;
border-radius:50%;
background-color:rgba(0, 0, 0, .6);
position:absolute;
left:0;
bottom:0;
right:0;
top:0;
margin: auto;
text-align:center;
`
const Percentage = styled.label`
line-height:190px;
font-size:8rem;
font-weight:700;
color:${colors.white};
`
const IntroText = styled.label`
font-size:3.3rem;
font-weight:700;
color:${colors.white};
span {
    color:${colors.lightblue};
}
position:absolute;
bottom:-60px;
right:0;
left:0;
`

class Loading extends Component {
    constructor() {
        super();
        this.setPercentage = this.setPercentage.bind(this);
        this.state = {
            percentage: 0
        }
    }
    componentDidMount() {
        this.timeout = window.setInterval(this.setPercentage, 40);
    }
    setPercentage() {
        let newPercentage = this.state.percentage + 1;
        if (newPercentage >= 100 || this.state.percentage >= 100) {
            newPercentage = 100;
            window.clearInterval(this.timeout);

            if (typeof this.props.onLoaded === 'function')
                this.props.onLoaded();
        }
        this.setState({
            percentage: newPercentage
        });
    }
    render() {
        return (
            <GeneralWrapper>
                <Header />
                <Container>
                    <LoaderContainer>
                        <InnerCircle>
                            <Percentage>{this.state.percentage}%</Percentage>
                        </InnerCircle>
                        <SvgCircle percentage={this.state.percentage} />
                        <IntroText>
                            <span>אנא המתן, </span>
                            והגבר את הווליום
                        </IntroText>
                    </LoaderContainer>
                </Container>
                <Footer />
            </GeneralWrapper>
        )
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/pages/Loading.jsx